
export default class SongCategory {
  name: string; //e.g. Rookie Songs, Intermediate Songs, Advanced Songs
  categoryType: number; //e.g. 2, 3, 4
  constructor({name, categoryType}: SongCategory) {
    Object.assign(this, {name, categoryType});
  }
}